import React, {
  createContext,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
  useContext,
} from 'react';
import { Concierge, ConciergeDocument, ConciergeQuery } from '../gql/graphql';
import API from '../utils/API';
import { useNavigation } from '@react-navigation/native';
import LoginScreen from '../screens/LoginScreen';
import HttpClient from '../utils/HttpClient';

const AuthContext = createContext({});

export const useAuthContext = () => useContext(AuthContext);

const AuthProvider = (props: PropsWithChildren<any>) => {
  const [currentUser, setCurrentUser] = useState<Concierge | undefined>();
  const navigationRefObj = props.navigationRef;

  const fetchCurrentUser = () => {
    return HttpClient.graphqlQuery(ConciergeDocument)
      .then((data: ConciergeQuery) => {
        setCurrentUser(data.me);
      })
      .catch(() => {
        if (navigationRefObj?.current && typeof navigationRefObj.current.navigate === 'function') {
          navigationRefObj.current.navigate('Login');
        }
      });
  };

  useEffect(() => {
    if (navigationRefObj?.current) {
      fetchCurrentUser();
    }
  }, [navigationRefObj?.current]);

  return (
    <AuthContext.Provider value={{ currentUser, setCurrentUser, fetchCurrentUser }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
